<template>
  <div class="home">
    <Featured />

    <div class="row my-4">
      <div class="col-md-8 mb-3">
        <div v-for="post in posts">
          <div style="position:relative;">
            <h3 v-html="post.title.rendered">{{ post.title.rendered }}</h3>
            <ul class="list-inline mb-2">
              <li class="text-muted">
                {{ post.date | moment("dddd, MMMM D, YYYY") }} at {{ post.date | moment("h:mm a") }}
              </li>
              <li class="text-muted">
                <PostCategory v-bind:categoryid="post.categories" />
              </li>
            </ul>
            <div v-html="post.excerpt.rendered">{{ post.excerpt.rendered }}</div>
            <router-link :to="{ name: 'post', params: { slug: post.slug }}" class="stretched-link">Continue reading</router-link>

            <hr>
          </div>
        </div>


        <div class="row align-items-center">
          <div class="col-3 text-right">
            <button class="btn btn-link" v-on:click="currentpage -= 1" v-if="showprev">
              <i class="fas fa-angle-double-left fa-2x"></i>
            </button>
          </div>
          <div class="col-6 text-center">
            Page {{ currentpage }} of {{ totalpages }}
          </div>
          <div class="col-3">
            <button class="btn btn-link" v-on:click="currentpage += 1">
              <i class="fas fa-angle-double-right fa-2x"></i>
            </button>
          </div>
        </div>

      </div>
      <div class="col-md-4 d-none d-md-block">
        <NewsletterSignUp />
        <SearchForm />
        <CardShareNoteNews />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Featured from '@/components/Featured.vue';
import LatestPosts from '@/components/LatestPosts.vue';
import NewsletterSignUp from '@/components/NewsletterSignUp.vue';
import SearchForm from '@/components/SearchForm.vue';
import CardShareNoteNews from '@/components/CardShareNoteNews.vue';

export default {
  title: 'ShareNote.com Support Center',
  name: 'home',
  components: {
    Featured,
    LatestPosts,
    NewsletterSignUp,
    SearchForm,
    CardShareNoteNews,
  },
  data() {
    return {
      posts: [],
      errors: [],
      currentpage: 1,
      showprev: false,
      shownext: false,
      totalpages: 0,
      totalposts: 0
    }
  },
  watch: {
    currentpage(newcurrentpage) {
      this.getCurrentPage(newcurrentpage);
    },
    totalpages(newtotalpage) {
      this.getCurrentPage(this.currentpage);
    }
  },
  methods: {
    getLatestPosts() {
      axios.get('https://wpapi.sharenote.com/wp-json/wp/v2/posts?per_page=5&page=' + this.currentpage + '&categories=1')
      .then(response => {
        this.posts = response.data;
        this.headerinfo = response.headers;
        //console.log(this.headerinfo);
        this.totalpages = Number(this.headerinfo['x-wp-totalpages']);
        this.totalposts = Number(this.headerinfo['x-wp-total']);
        //console.log(response.headers.get('x-wp-total'));
        //console.log(response.headers.get('x-wp-totalpages'));
      })
      .catch(e => {
        this.errors.push(e)
      })
    },
    getCurrentPage(page) {
      if (page <= 1) {
        this.currentpage = 1;
        this.showprev = false;
      } else {
        this.currentpage = page;
        this.showprev = true;
      }

      if (this.currentpage < this.totalpages) {
        this.shownext = true;
      } else {
        this.shownext = false;
      }

      this.getLatestPosts();
    }
  },
  created() {
    this.getLatestPosts();
  }
}
</script>
